import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';

export interface APIErrorResponse {
	errors?: Array<{
		detail?: string;
		title?: string;
		status?: number;
	}>;
}

export function isFetchBaseQueryError(error: unknown): error is FetchBaseQueryError {
	return typeof error === 'object' && error !== null && 'status' in error;
}

export function isSerializedError(error: unknown): error is SerializedError {
	return typeof error === 'object' && error !== null && 'message' in error;
}
